export default "__VITE_ASSET__9f86a6d8__"